import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getBankAccount, getLegalDocument, pushGaStepEvent } from 'actions/loan';
import Spinner from 'components/Credit24/Core/Spinner';
import Submit from 'components/Credit24/LoanApplication/SubmitAU';

const propTypes = {
  authentication: PropTypes.object.isRequired,
  loan: PropTypes.object.isRequired,
  getLegalDocument: PropTypes.func.isRequired,
  getBankAccount: PropTypes.func.isRequired,
  pushGaStepEvent: PropTypes.func,
};

class SubmitAUContainer extends Component {
  UNSAFE_componentWillMount() {
    if (this.props.authentication.isAuthenticated) {
      this.props.getLegalDocument();
      this.props.getBankAccount();
    }

    if (INCREASE_APP) {
      this.props.pushGaStepEvent('checkoutSelfservice', { page: 'legal' });
    }
  }

  render() {
    const { loan, authentication } = this.props;
    const { legalDocument, bsb, accountNumber } = loan;
    if (loan.isContentLoading || authentication.isLoading || !legalDocument) {
      return (
        <div className="loan-form__step loan-form__step--loading">
          <Spinner />
        </div>
      );
    }

    return (
      <Submit
        legalDocument={legalDocument}
        bsb={bsb}
        accountNumber={accountNumber}
      />
    );
  }
}

SubmitAUContainer.propTypes = propTypes;

export default connect(
  null,
  { getLegalDocument, getBankAccount, pushGaStepEvent }
)(SubmitAUContainer);
